/* RESPONSIBLE TEAM: team-automation-foundations */
import { buildValidations, validator } from 'ember-cp-validations';
import { alias, not } from '@ember/object/computed';

export default buildValidations({
  botMode: [validator('presence', true)],
  emailFollowUpTimer: [
    validator('number', {
      allowNone: true,
      integer: true,
      gte: 60 * 60, // 1 hour
      lte: 30 * 24 * 60 * 60, // 30 days
      messageKey: 'operator.workflows.visual-builder.validations.fin.follow-up-timer',
    }),
  ],
  botIntroLocalizations: [
    validator('has-many', {
      disabled: alias('model.disableLocalizationsValidation'),
    }),
  ],
  botOnlyMessageLocalizations: [
    validator('has-many', {
      disabled: alias('model.disableBotOnlyMessageLocalizationsValidation'),
      dependentKeys: ['model.botMode'],
    }),
  ],
  genericTriageLocalizations: [
    validator('all-generic-triages-are-valid-or-disabled', {
      disabled: alias('model.disableGenericTriageValidation'),
    }),
  ],
  hasConsentToExternalAiDataProcessing: [
    validator('has-consent-to-external-ai-data-processing', {
      disabled: not('model.useAiAnswers'),
      dependentKeys: ['model.useAiAnswers', 'appService.app.canUseExternalAi'],
    }),
  ],
});
